import React from 'react';

export default function StickyFooter(props) {
    return (
        <footer className="sticky-footer border-top white-bg p-3">
          {props.children}
        </footer>
    );
}
  

